import OapPopin from './code/Scripts/components/OapPopin.vue';

export default {
  components: {
    OapPopin,
  },
};
